import { render, staticRenderFns } from "./CustomForm.vue?vue&type=template&id=32754bcb&scoped=true&"
import script from "./CustomForm.vue?vue&type=script&lang=js&"
export * from "./CustomForm.vue?vue&type=script&lang=js&"
import style0 from "./CustomForm.vue?vue&type=style&index=0&id=32754bcb&prod&lang=scss&"
import style1 from "./CustomForm.vue?vue&type=style&index=1&id=32754bcb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../PatientEnrollment/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32754bcb",
  null
  
)

export default component.exports